import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    marginBottom: '0',
  },
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingTop: '0.5rem',
    paddingBottom: '0',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      alignItems: 'stretch',
    },
  },
  buttonsContainer: {
    display: 'flex',
    gap: theme.spacing(1),
    alignItems: 'center',
    flexWrap: 'wrap',
    [theme.breakpoints.down('md')]: {
      width: '100%',
      justifyContent: 'flex-start',
    },
    [theme.breakpoints.down('sm')]: {
      gap: theme.spacing(0.5),
    },
  },
  documentButton: {
    backgroundColor: '#fff',
    color: '#000',
    textTransform: 'none',
    borderRadius: '20px',
    padding: '6px 16px',
    border: '1px solid #000',
    fontWeight: theme.typography.fontWeightMedium,
    fontSize: '14px',
    minHeight: '34px',
    height: '34px',
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    [theme.breakpoints.down('md')]: {
      fontSize: '13px',
      padding: '5px 14px',
      height: '32px',
      minHeight: '32px',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px',
      padding: '4px 12px',
      height: '30px',
      minHeight: '30px',
    },
    [theme.breakpoints.down('xs')]: {
      flex: '1 1 calc(50% - 4px)',
      minWidth: 'calc(50% - 4px)',
    },
    '&:hover': {
      backgroundColor: '#000000',
      color: '#fff',
      border: '1px solid #000',
    },
  },
  uploadButton: {
    backgroundColor: '#ec6535',
    color: '#fff',
    textTransform: 'none',
    borderRadius: '2rem',
    minWidth: '180px',
    height: '40px',
    padding: '8px 20px',
    '&:hover': {
      backgroundColor: '#000000',
      color: '#fff',
    },
  },
  searchContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: 0,
    width: '400px',
    maxWidth: '400px',
    [theme.breakpoints.down('md')]: {
      width: '100%',
      maxWidth: '100%',
      marginTop: theme.spacing(1),
    },
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      gap: theme.spacing(1),
    },
  },
  searchInput: {
    flex: 1,
    minWidth: 0,
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
    '& .MuiOutlinedInput-root': {
      height: '40px',
      borderRadius: '4px 0 0 4px',
      [theme.breakpoints.down('md')]: {
        height: '36px',
      },
      [theme.breakpoints.down('sm')]: {
        height: '34px',
        borderRadius: '4px',
      },
      '& fieldset': {
        borderColor: '#000',
        borderWidth: '1px',
      },
      '&:hover fieldset': {
        borderColor: '#000',
        borderWidth: '1px',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#000',
        borderWidth: '2px',
      },
    },
    '& input': {
      [theme.breakpoints.down('md')]: {
        fontSize: '13px',
      },
      [theme.breakpoints.down('sm')]: {
        fontSize: '12px',
      },
    },
  },
  searchButton: {
    height: '40px',
    minWidth: '48px',
    padding: '0',
    borderRadius: '0 4px 4px 0',
    backgroundColor: '#EB5E28',
    color: '#fff',
    border: '1px solid #000',
    borderLeft: 'none',
    [theme.breakpoints.down('md')]: {
      height: '36px',
      minWidth: '44px',
    },
    [theme.breakpoints.down('sm')]: {
      height: '34px',
      minWidth: '100%',
      borderRadius: '4px',
      borderLeft: '1px solid #000',
    },
    '&:hover': {
      backgroundColor: '#d35400',
    },
  },
}));


